import { useEffect } from "react";
import usePrevious from "utils/hooks/usePrevious";

const useObserveEventSubtypeId = ({ eventSubtypeId, changeEventGraphicId }) => {
	const prevEventSubtypeId = usePrevious(eventSubtypeId);
	useEffect(() => {
		observeEventSubtypeId();
	}, [eventSubtypeId]);
	function observeEventSubtypeId() {
		if (prevEventSubtypeId && eventSubtypeId > 0) changeEventGraphicId(0);
	}
};

export default useObserveEventSubtypeId;
